import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ForwarderService, PagerService, AlertService, CommonService, TableHeader, AnnouncedfareFwdrList, OceanLine, OceanLineService, AnnouncedfareFwdrReqBody } from '../../services/index'
import { Util } from '../../utils/index';
declare var $:any;
import _ from 'lodash';



@Component({
  selector: 'announced-line',
  templateUrl: 'announced-line.html' 
})
export class AnnouncedLineContainer {
  getFwdrLineListSub:Subscription;
  updateCFwdrLineStatusSub:Subscription;

  getLocaleTime: Function = Util.getLocaleTime;
  fwdrList:Array<AnnouncedfareFwdrList>;
  tempFwdrList:Array<AnnouncedfareFwdrList>;
  pager: any = {};
  pagedItems:any[];
  searchOption:SearchOption = new SearchOption();
  headerList:Array<TableHeader> = null;
  clickedHader:TableHeader;
  oceanLineList: OceanLine[] = [];

  reqList: AnnouncedfareFwdrReqBody[];

  @Output() headerSortedEmit: EventEmitter<any> = new EventEmitter();
  @Output() clearHeaderEmit: EventEmitter<any> = new EventEmitter();
  

  constructor(
    private fwdrService: ForwarderService, 
    private pagerService: PagerService, 
    private alertService:AlertService, 
    private commonService:CommonService,
    private oceanLineService:OceanLineService
  ) {

    this.oceanLineList = this.oceanLineService.lineList;

    if(_.isEmpty(this.oceanLineList)) {
      this.oceanLineService.lineListEe.subscribe(
        oceanLineList => {
          this.oceanLineList = oceanLineList;
        }
      );
    }

    commonService.headerSortedEmit.subscribe(sortedData =>{
      this.tempFwdrList = sortedData;
      this.setPage(1);
    });
    commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }
  
  ngOnInit() {

    if(this.fwdrService.fwdrLineSearchOption != null){
      this.searchOption = this.fwdrService.fwdrLineSearchOption;
    }

    if(this.fwdrService.fwdrLinePager != null){
      this.pager = this.fwdrService.fwdrLinePager;
      this.search(this.pager.currentPage);
    }else{
      this.search(1);
    }

    if(this.fwdrService.fwdrLineHeader != null){
      this.headerList = this.fwdrService.fwdrLineHeader;
    }else{
      this.makeHeader();
    }
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'entrpsNm', '포워더 명', true));
    this.headerList.push(new TableHeader(1, 'lineNm', '맵핑된 선사명', true));
    this.headerList.push(new TableHeader(2, 'line-selector', '변경할 선사 선택', false));    
    this.headerList.push(new TableHeader(3, 'hideYn', '숨김처리', true));
    this.headerList.push(new TableHeader(4, 'insDtm', '입력날짜', true));
    this.headerList.push(new TableHeader(5, 'edit', '수정', false));
    this.headerList.push(new TableHeader(6, 'del', '삭제', false));
  }

  ngOnDestroy(){
    if(this.getFwdrLineListSub) this.getFwdrLineListSub.unsubscribe();
    if(this.updateCFwdrLineStatusSub) this.updateCFwdrLineStatusSub.unsubscribe();
  }

  search(page){
    this.getFwdrLineListSub = this.fwdrService.getFwdrLineList(resp => {
        this.fwdrList = resp;
        this.tempFwdrList = this.fwdrList;
  
        if(this.fwdrService.fwdrLineClickedHeader != null){
          this.clickedHader = this.fwdrService.fwdrLineClickedHeader;
          
          if(this.clickedHader.orderBy.indexOf("ASC") > -1){
            this.clickedHader.orderBy = 'DESC';
          }else{
            this.clickedHader.orderBy = 'ASC';
          }
  
          this.commonService.headerClick(this.clickedHader, this.tempFwdrList);
        }
  
        this.conditionSearch(page);
      }
      
    );
  }
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.tempFwdrList.length, page);
    // if (page < 1) {
    //   return;
    // } 
    
    this.pagedItems = this.tempFwdrList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    
  }

  selectLine(event, fwdr:AnnouncedfareFwdrList) {
    if(event == null) return;
    if(event.lineCd == fwdr.lineCd) return;
    
    fwdr.lineCd = event.lineCd;  
    fwdr.selectedLine = event;
    
    if(_.isEmpty(this.reqList)) {
      this.reqList = [];
    }

    let alreadyIn = null;
    if(!_.isEmpty(this.reqList)) {
      alreadyIn = _.find(this.reqList, {entrpsNm : fwdr.entrpsNm});
    }

    if(alreadyIn != null) {
      alreadyIn.lineCd = event.lineCd;
    } else {
      let newReq = new AnnouncedfareFwdrReqBody();

      newReq.entrpsNm = fwdr.entrpsNm;
      newReq.lineCd = event.lineCd;

      this.reqList.push(newReq);
    }
  }

  changeHideNo(event, fwdr:AnnouncedfareFwdrList) {
    this.fwdrService.patchFareLineShow(fwdr.entrpsNm, resp => {
      this.alertService.success('선사가 공개로 변경되었습니다.');
      fwdr.hideYn = 'N';
    },
    err => {
      this.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
    })
  }

  changeHideYes(event, fwdr:AnnouncedfareFwdrList) {
    this.fwdrService.patchFareLineHide(fwdr.entrpsNm, resp => {
      this.alertService.success('선사가 숨김으로 변경되었습니다.');
      fwdr.hideYn = 'Y';
    },
    err => {
      this.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
    })
  }

  editLine(event, fwdr){
    event.stopPropagation();
    let that = this;
    let reqBody = [{entrpsNm : fwdr.entrpsNm, lineCd:fwdr.lineCd}];
    $.sweetModal.confirm("매핑된 선사를 변경하시겠습니까?", function() {
      that.fwdrService.postFwdrLineList(reqBody, resp => {
          that.alertService.success('선사 변경이 완료되었습니다.');
          fwdr.line = _.find(that.oceanLineList, {lineCd : fwdr.lineCd});
          fwdr.selectedLine = null;
          if(!_.isEmpty(this.reqList)) {
            let findFwdrIndex = _.findIndex(this.reqList, {entrpsNm : fwdr.entrpsNm});
            if(findFwdrIndex > -1) {
              this.reqList.splice(findFwdrIndex, 1);
            }
          }
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
        },
        () => {

        }
      );
    });
  }

  saveAll(event) {
    event.stopPropagation();
    let that = this;
    let reqBody = this.reqList;
    $.sweetModal.confirm("매핑된 선사를 변경하시겠습니까?", function() {
      that.fwdrService.postFwdrLineList(reqBody, resp => {
          that.alertService.success('선사 변경이 완료되었습니다.');
          that.search(that.pager.currentPage);
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.')
        },
        () => {

        }
      );
    });
  }

  deleteLine(event, fwdr) {
    
    event.stopPropagation();
    let that = this;
    let reqBody = [{entrpsNm : fwdr.entrpsNm, lineCd:null}];
    $.sweetModal.confirm("매핑된 선사를 삭제하시겠습니까?", function() {
      that.fwdrService.postFwdrLineList(reqBody, resp => {
          that.alertService.success('선사 삭제가 완료되었습니다.');
          fwdr.line = null;
          if(!_.isEmpty(this.reqList)) {
            let findFwdrIndex = _.findIndex(this.reqList, {entrpsNm : fwdr.entrpsNm});
            if(findFwdrIndex > -1) {
              this.reqList.splice(findFwdrIndex, 1);
            }
          }
        },
        err => {
          that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
        },
        () => {

        }
      );
    });
    
  }

  conditionSearch(page?:number){
    if(_.isEmpty(this.fwdrList)) return;
    let keyword = _.upperCase(this.searchOption.conditionText).replace(/\s/gi, "");
    let statusCd = this.searchOption.conditionType;
    let hideYnCd = this.searchOption.hideType;
    this.tempFwdrList = _.map(_.filter(this.fwdrList,
      (fwdr:AnnouncedfareFwdrList) => {
        if(!keyword) return true;
        else if (_.upperCase(fwdr.entrpsNm ? fwdr.entrpsNm : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.line.lineNm ? fwdr.line.lineNm : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else if (_.upperCase(fwdr.lineCd ? fwdr.lineCd : '').replace(/\s/gi, "").indexOf(keyword) >= 0) return true;
        else return false;
      }));
    this.tempFwdrList = _.map(_.filter(this.tempFwdrList,
      (fwdr:AnnouncedfareFwdrList) => {
        if(statusCd == 'ALL') return true;
        else if(statusCd == 'YES') {
          if(fwdr.line && fwdr.line.lineCd) return true;
          else return false;
        }
        else if(statusCd == 'NO') {
          if(!fwdr.line || (fwdr.line && !fwdr.line.lineCd)) return true;
          else return false;
        }
      }));
      this.tempFwdrList = _.map(_.filter(this.tempFwdrList, 
        (fwdr:AnnouncedfareFwdrList) => {
          if(hideYnCd == 'ALL') return true;
        else if(hideYnCd == 'YES') {
          if(fwdr.hideYn == 'Y') return true;
          else return false;
        }
        else if(hideYnCd == 'NO') {
          if(fwdr.hideYn == 'N') return true;
          else return false;
        }

        }));
    this.setPage(page == null || page == undefined ? 1 : page);
    this.commonService.clearOrderByHeader(this.headerList);
  }
  selectConditionType(event){
    this.searchOption.conditionType = event;
    this.conditionSearch();
  }

  selectHideType(event) {
    this.searchOption.hideType = event;
    this.conditionSearch();
  }

  handleKeyDown(event){
    if(event.keyCode == 13) this.conditionSearch();
  }

  headerClick(header:TableHeader){
    this.clickedHader = header;
    this.fwdrService.fwdrLineClickedHeader = header;
    this.commonService.headerClick(header, this.tempFwdrList);
  }
  

}

class SearchOption {
  conditionText:string;
  conditionType:string = 'ALL';
  hideType:string = 'ALL';
}



// WEBPACK FOOTER //
// ./src/app/containers/announced-fare/announced-line.ts